export const DIVISIONS = {
  ndt_materials: {
    key: "ndt_materials",
    slug: "ndt-materials",
    label: "NDT Materials",
    short: "NDT Materials",
    color: "#0F2747",
    tagline: "Dye Penetrant & Magnetic Particle Inspection Consumables",
  },
  ndt_equipment: {
    key: "ndt_equipment",
    slug: "ndt-equipment",
    label: "NDT Equipment & Accessories",
    short: "NDT Equipment",
    color: "#0F2747",
    tagline: "UV Lamps, Yokes, Meters, Reference Blocks & Accessories",
  },
  klyde_zinc: {
    key: "klyde_zinc",
    slug: "klyde-zinc-materials",
    label: "KLYDE Zinc Materials",
    short: "KLYDE Zinc",
    color: "#475569",
    tagline: "Cold Galvanizing, Zinc Sprays & Protective Coatings",
  },
  bearings: {
    key: "bearings",
    slug: "industrial-bearings",
    label: "Industrial Bearings",
    short: "Industrial Bearings",
    color: "#1E293B",
    tagline: "NTN & Industrial Bearings for Machinery & Maintenance",
  },
  bessey: {
    key: "bessey",
    slug: "bessey-clamps",
    label: "BESSEY Clamps",
    short: "BESSEY",
    color: "#B5121B",
    tagline: "Premium German clamping and cutting tools for industrial applications",
  },
};

// Level-1 product categories shown on the /products landing page
export const CATEGORIES = {
  "dye-penetrant-testing": {
    slug: "dye-penetrant-testing",
    label: "Dye Penetrant Testing",
    short: "DPT",
    division: "ndt_materials",
    tagline: "MR Chemie penetrant testing consumables — cleaners, penetrants and developers",
    image: "/products/cat-dpt.jpg",
    includes: ["Cleaners", "Visible Penetrants", "Fluorescent Penetrants", "Developers", "Water-Washable Systems", "Solvent-Removable Systems"],
  },
  "magnetic-particle-inspection": {
    slug: "magnetic-particle-inspection",
    label: "Magnetic Particle Inspection",
    short: "MPI",
    division: "ndt_materials",
    tagline: "Wet and dry method MPI consumables for weld & casting inspection",
    image: "/products/cat-mpi.jpg",
    includes: ["Magnetic Inks", "Magnetic Powders", "Contrast Paints", "Fluorescent Magnetic Particles", "White Background Paint", "MPI Consumables"],
  },
  "ndt-equipment-accessories": {
    slug: "ndt-equipment-accessories",
    label: "NDT Equipment & Accessories",
    short: "Equipment",
    division: "ndt_equipment",
    tagline: "UV lamps, hand yokes and measuring instruments",
    image: "https://images.pexels.com/photos/2760241/pexels-photo-2760241.jpeg?auto=compress&cs=tinysrgb&w=1200",
    includes: ["UV Lamps", "Yoke Machines", "Lux Meters", "UV Intensity Meters", "Field Indicators", "Inspection Accessories"],
  },
  "test-reference-blocks": {
    slug: "test-reference-blocks",
    label: "Test & Reference Blocks",
    short: "Test Blocks",
    division: "ndt_equipment",
    divisionLabel: "NDT Reference Standards",
    tagline: "Reference blocks for process qualification & sensitivity checks",
    image: "/products/test-blocks-illustration.svg",
    includes: ["Reference Test Blocks", "Comparator Blocks", "Penetrant Test Panels", "Magnetic Particle Test Blocks", "Customized Test Blocks"],
  },
  "klyde-zinc-materials": {
    slug: "klyde-zinc-materials",
    label: "KLYDE Zinc Materials",
    short: "KLYDE Zinc",
    division: "klyde_zinc",
    tagline: "Cold galvanizing sprays, zinc-rich primers and protective coatings",
    image: "/products/cat-zinc.jpg",
    includes: ["Zinc Spray", "Cold Galvanizing Spray", "Zinc Rich Primer", "Zinc Paint", "Industrial Protective Coatings"],
  },
};


export const INDUSTRIES = [
  { name: "Aerospace", icon: "Plane" },
  { name: "Defence", icon: "Shield" },
  { name: "Railways", icon: "Train" },
  { name: "Heavy Engineering", icon: "Wrench" },
  { name: "Power Generation", icon: "Zap" },
  { name: "Oil & Gas", icon: "Flame" },
  { name: "Steel Fabrication", icon: "Hammer" },
  { name: "Infrastructure", icon: "Building2" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Casting", icon: "Layers" },
  { name: "Forging", icon: "Anvil" },
  { name: "Metallurgical", icon: "Atom" },
  { name: "Galvanizing Plants", icon: "Droplets" },
  { name: "Pressure Vessels", icon: "Container" },
  { name: "Boiler Manufacturing", icon: "Cylinder" },
  { name: "Wind Energy", icon: "Wind" },
  { name: "Solar Manufacturing", icon: "Sun" },
  { name: "Automotive", icon: "Car" },
  { name: "Engineering Workshops", icon: "Cog" },
  { name: "Machine Builders", icon: "Settings" },
];

export const PACKAGING_OPTIONS = ["400ml", "500ml", "1L", "5L", "Other"];
